module.exports = __webpack_public_path__ + "img/44.01955ba5.jpg";